import { ExternalLink, X, Link2, Trash2 } from "lucide-react";

export function LinksBar({ links, onOpen, onRemove, onClear }) {
  if (!links.length) return null;
  return (
    <div className="hud-panel reticle clip-corner mt-5" data-testid="links-bar">
      <span className="rc-tr" />
      <span className="rc-bl" />
      <div className="flex items-center justify-between px-4 py-2.5 border-b border-[var(--border-hud)]">
        <div className="flex items-center gap-2">
          <Link2 className="h-3.5 w-3.5 accent-text" />
          <span className="font-mono-hud text-[11px] tracking-[0.25em] uppercase accent-text">
            LIENS OUVERTS // {links.length}
          </span>
        </div>
        <button
          data-testid="links-clear-button"
          onClick={onClear}
          className="flex items-center gap-1 font-mono-hud text-[10px] tracking-widest text-[#8b949e] hover:text-[#ff6b6b] transition-colors"
        >
          <Trash2 className="h-3 w-3" />
          VIDER
        </button>
      </div>

      <div className="flex flex-wrap gap-2 px-4 py-3">
        {links.map((l) => (
          <div
            key={l.id}
            data-testid="link-chip"
            className="group flex items-center gap-2 pl-2 pr-1 py-1.5 bg-[rgba(255,255,255,0.03)] border border-[var(--border-hud)] clip-corner hover:bg-[var(--accent-a10)] transition-colors animate-rise"
          >
            <img
              src={`https://www.google.com/s2/favicons?domain=${l.host}&sz=32`}
              alt=""
              width={16}
              height={16}
              className="rounded-sm shrink-0"
              onError={(e) => {
                e.currentTarget.style.display = "none";
              }}
            />
            <button
              data-testid="link-open-button"
              onClick={() => onOpen(l.url)}
              title={l.url}
              className="flex items-center gap-1.5 text-[13px] text-[#dbe7f3] hover:text-white max-w-[220px] truncate"
            >
              <span className="truncate">{l.host}</span>
              <ExternalLink className="h-3 w-3 accent-text shrink-0" />
            </button>
            <button
              data-testid="link-remove-button"
              onClick={() => onRemove(l.id)}
              aria-label="Retirer"
              className="h-5 w-5 flex items-center justify-center text-[#6b7a8d] hover:text-[#ff6b6b] hover:bg-[rgba(255,107,107,0.12)] rounded transition-colors"
            >
              <X className="h-3 w-3" />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
